import { ModifierConseignSecurite } from '../../editMachine/modifierConseignSecurite';
import { ModifierCaracteristique } from '../../editMachine/modifierCaracteristique';
import { ModifierModeEmploi } from '../../editMachine/modifierModeEmploi';
import { ModifierEvalUtilisation } from '../../editMachine/modifierEvalUtilisation';
import MachineEvalUtilisationSection from '../../MachineEvalUtilisationSection';
import { useHasPermission } from '../../../../hooks/useHasPermission';
import calenderChecked from '../../../../images/calenderChecked.svg';
import { FormatDate } from '../../../../utils/formatDate';
import calender from '../../../../images/calender.svg';
import { Box, Typography, Grid } from '@mui/material';
import measure from '../../../../images/measure.svg';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Iconify from '../../../Iconify';
import RichTextDisplay from '../../../richText/RichTextDisplay';
import { useState } from 'react';
import {
  formatMachineElectricPower,
  formatMachineIntensity,
  MACHINE_INTENSITY_LABEL,
} from '../../../../utils/machineElectricalDisplay';
import '../../../../css/machines/modeEtConsigne.css';

const ModeEtConsigne = () => {

    const { t } = useTranslation();
    const machineDetailsData = useSelector((state) => state.MachineDetailsData);
    const hasMachineUpdatePermission = useHasPermission('machine_update');

    const [modifyModeEmploi, setModifyModeEmploi] = useState(false);
    const [modifyConseignSecurite, setModifyConseignSecurite] = useState(false);
    const [modifyCaracteristique, setModifyCaracteristique] = useState(false);
    const [modifyEvalUtilisation, setModifyEvalUtilisation] = useState(false);

    const CharacteristicBox = ({ icon, image, title, value }) => {
        return (
            <Box className='modeEtConsigne_caracteristique_text_box'>
                {icon ? (
                    <Iconify className='modeEtConsigne_caracteristique_icons' icon={icon} />
                ) : (
                    <img src={image} alt="icon" className='modeEtConsigne_caracteristique_icons' loading='lazy' decoding='async' />
                )}
                <Box className='modeEtConseigne_icon_title_response_box'>
                    <Typography className='modeEtConsigne_caracteristique_text'>{title}</Typography>
                    <Typography className='modeEtConseigne_text_response'>{value ? value : '--'}</Typography>
                </Box>
            </Box>
        );
    };

    return (
        <Box className='modeEtConsigne_main_box'>
            <Box className='modeEtConsigne_box'>
                <Box className='modeEtConsigne_edit_box'>
                    <Typography className='modeEtConsigne_title'>{t('Mode d’emploi')}</Typography>
                    {hasMachineUpdatePermission && !machineDetailsData?.is_archived && <Iconify className='modeEtConsigne_edit_icon' icon={"ic:outline-edit"} onClick={() => setModifyModeEmploi(true)} />}
                </Box>
                {machineDetailsData?.Instructions_for_use ?
                    <RichTextDisplay html={machineDetailsData.Instructions_for_use} className='publicRichBody' /> :
                    <Typography className='modeEtConsigne_dashed_typography'>{t('Il n’existe aucun contenu dans cette section')}</Typography>
                }
            </Box>
            <Box className='modeEtConsigne_box'>
                <Box className='modeEtConsigne_edit_box'>
                    <Typography className='modeEtConsigne_title'>{t('Mesures de prévention')}</Typography>
                    {hasMachineUpdatePermission && !machineDetailsData?.is_archived && <Iconify className='modeEtConsigne_edit_icon' icon={"ic:outline-edit"} onClick={() => setModifyConseignSecurite(true)} />}
                </Box>
                {machineDetailsData?.Safety_instructions ?
                    <RichTextDisplay html={machineDetailsData.Safety_instructions} className='publicRichBody' /> :
                    <Typography className='modeEtConsigne_dashed_typography'>{t('Il n’existe aucun contenu dans cette section')}</Typography>
                }
            </Box>
            <MachineEvalUtilisationSection
                evalUtilisationUrl={machineDetailsData?.eval_utilisation_url}
                canEdit={hasMachineUpdatePermission && !machineDetailsData?.is_archived}
                onEdit={() => setModifyEvalUtilisation(true)}
            />
            <Box className='modeEtConsigne_caracteristique_box'>
                <Box className='modeEtConsigne_edit_box'>
                    <Typography className='modeEtConsigne_title'>{t('Caractéristiques')}</Typography>
                    {hasMachineUpdatePermission && !machineDetailsData?.is_archived && <Iconify className='modeEtConsigne_edit_icon' icon={"ic:outline-edit"} onClick={() => setModifyCaracteristique(true)} />}
                </Box>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <CharacteristicBox
                            icon="gis:regular-shape-o"
                            title={t('Marque :')}
                            value={machineDetailsData?.marque?.name}
                        />
                        <CharacteristicBox
                            image={measure}
                            title={t('Dimensions :')}
                            value={(machineDetailsData?.length && machineDetailsData?.width && machineDetailsData?.height) ? `${machineDetailsData?.length} X ${machineDetailsData?.width} X ${machineDetailsData?.height}` : null}
                        />
                        <CharacteristicBox
                            icon="ic:baseline-qr-code"
                            title={t('Codification interne :')}
                            value={machineDetailsData?.internal_codification}
                        />
                        <CharacteristicBox
                            icon="material-symbols-light:electric-bolt-rounded"
                            title={t('Puissance électrique :')}
                            value={formatMachineElectricPower(machineDetailsData?.electric_power)}
                        />
                        <CharacteristicBox
                            image={calender}
                            title={t('Date de fabrication :')}
                            value={FormatDate(machineDetailsData?.manufacture_date)}
                        />
                        <CharacteristicBox
                            image={calenderChecked}
                            title={t('Date de mise en service :')}
                            value={FormatDate(machineDetailsData?.commissioning_date)}
                        />
                        <CharacteristicBox
                            icon="mdi:users-outline"
                            title={t('Destinée à :')}
                            value={machineDetailsData?.Dedicated_to}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <CharacteristicBox
                            icon="mdi:tag-outline"
                            title={t('Modèle :')}
                            value={machineDetailsData?.model}
                        />
                        <CharacteristicBox
                            icon="ic:outline-folder-open"
                            title={t('Type de machine :')}
                            value={machineDetailsData?.type}
                        />
                        <CharacteristicBox
                            icon="mdi:hashtag"
                            title={t('Numéro de série :')}
                            value={machineDetailsData?.serial_number}
                        />
                        <CharacteristicBox
                            icon="material-symbols:power-plug-outline"
                            title={`${t(MACHINE_INTENSITY_LABEL)} :`}
                            value={formatMachineIntensity(machineDetailsData?.intensity)}
                        />
                        <CharacteristicBox
                            image={calender}
                            title={t('Date d’achat :')}
                            value={FormatDate(machineDetailsData?.purchase_date)}
                        />
                        <CharacteristicBox
                            icon="mdi:euro"
                            title={t('Prix d’achat :')}
                            value={Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(machineDetailsData?.purchase_price)}
                        />
                    </Grid>
                </Grid>
            </Box>
            {modifyModeEmploi && <ModifierModeEmploi modifyModeEmploi={modifyModeEmploi} setModifyModeEmploi={setModifyModeEmploi} />}
            {modifyConseignSecurite && <ModifierConseignSecurite modifyConseignSecurite={modifyConseignSecurite} setModifyConseignSecurite={setModifyConseignSecurite} />}
            {modifyCaracteristique && <ModifierCaracteristique modifyCaracteristique={modifyCaracteristique} setModifyCaracteristique={setModifyCaracteristique} />}
            {modifyEvalUtilisation && (
                <ModifierEvalUtilisation
                    modifyEvalUtilisation={modifyEvalUtilisation}
                    setModifyEvalUtilisation={setModifyEvalUtilisation}
                />
            )}

        </Box>
    );
}

export default ModeEtConsigne;